<div class="qr-wrap">
  <i class="fa fa-cog qr-inner"></i>
  <qrcode [qrdata]="qrData" [margin]="0" [width]="256" [errorCorrectionLevel]="'M'"
            [elementType]="'svg'" [colorLight]="'#ffffff00'"></qrcode>
</div>
